import { render } from "./page-purchase.vue?vue&type=template&id=345f7231&scoped=true"
import script from "./page-purchase.vue?vue&type=script&lang=js"
export * from "./page-purchase.vue?vue&type=script&lang=js"

import "./page-purchase.vue?vue&type=style&index=0&id=345f7231&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-345f7231"

export default script